/*
 * File: LoggedInUser.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays and styles the Hello, Username! label in the Navigation menu
 */
import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import AppStore from "../Store";
import { withStyles } from "@material-ui/core/styles";
import { useStore } from "utils/useStore";

const styles = theme => ({
  title: {
    textAlign: "left",
    color: theme.palette.common.white,
    maxWidth: "80%",
    letterSpacing: theme.spacing(0.2),
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(-0.75),
    fontWeight: 500
  }
});

const LoggedInUser = ({ fullName, classes }) => {
  const appStore = useStore(AppStore);
  // just return the full name string
  if (fullName) {
    return appStore.userFullName;
  }

  return (
    <Typography variant="h6" className={classes.title}>
      Hello, {appStore.userName}!
    </Typography>
  );
};

LoggedInUser.propTypes = {
  fullName: PropTypes.bool,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(observer(LoggedInUser));
